import HttpRequest from './HttpRequest'

class ProportionOfContactTypesProvider extends HttpRequest {
  findAll (query) {
    return this.get('/proportion-of-contact-types/', query)
  }
}

export default ProportionOfContactTypesProvider
